module.exports = __webpack_public_path__ + "static/media/video.b1bdea90.svg";